import React, { useState, useContext } from 'react'
import { useTranslation } from "react-i18next"
import { useDispatch } from 'react-redux'
import { M_StateActions, M_Table, LoadingContext, BufferService } from 'src/components/M_Components'

export const RoleConfig = ({ roles, onCreateTab, toastMessages }) => {
    const dispatch = useDispatch()
    const { t } = useTranslation()
    const [refresh, setRefresh] = useState(false)
    const ctx = useContext(LoadingContext)
    const removeContextItems = ['Print', 'Copy', 'View']
    const bufferSersiceRole = new BufferService('role/delete')

    const NewRoute = (url, label, operation, data) => {
        dispatch(M_StateActions.addM_State({ key: 'operation', value: operation }))
        if (operation === 'Edit' || operation === 'Copy' || operation === 'View') {
            if (!data) {
                toastMessages('error', '', t("SelectedLine"))
                return
            }
            dispatch(M_StateActions.addM_State({ key: 'rolesLine', value: data }))
        }
        if (operation === 'Create') {
            onCreateTab(url, label)
        }
        else if (operation === 'Edit' || operation === 'Copy' || operation === 'View') {
            onCreateTab(url, `${label} "${data.Name}"`)
        }
    }

    const deleteRole = (data) => {
        console.log(data)
        data.map(item => {
            bufferSersiceRole.delete(item.Id).then(ResData => {
                if (ResData.name === 'AxiosError') {
                    toastMessages('error', '', t("ErrorDelete"))
                    return
                }
                toastMessages('success', '', t("SuccessDelete"))
                setRefresh(true)
            })
        })
    }

    return (
        <div className='divGlobalSettings'>
            <div className='subTitleSettings'>
                <div>
                    <div style={{ color: ctx.secondaryColor }}>
                        Roles
                    </div>
                    <div className='labelSubtitleSettings'>
                        {t("InfoPanelRoles")}
                    </div>
                </div>
            </div>
            <M_Table
                entityName={'Role'}
                roleName={'role config'}
                rolePermissions={roles}
                removeContextItems={removeContextItems}
                refresh={refresh}
                setRefresh={setRefresh}
                useSessionStorage={false}
                replaceFunctions={new Map([
                    ['Edit', (e) => NewRoute('RoleConfigCrud', t('LabelEditRoles'), 'Edit', e)],
                    ['Create', (e) => NewRoute('RoleConfigCrud', t('LabelCriarRoles'), 'Create', e)],
                    ['Delete', (data) => deleteRole(data)],
                ])}
            />
        </div>
    )
}
